export default __webpack_public_path__ + "static/media/counter.889bd711.svg";